import { render } from "./GuideHeader.vue?vue&type=template&id=279de148"
import script from "./GuideHeader.vue?vue&type=script&lang=js"
export * from "./GuideHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__